<template>
<div>
    <v-container grid-list-md fluid>
        <v-layout row wrap fill-height>
            <v-card outlined class="pa-2" style="min-height: 418px; min-width: 100%;">
                <v-sheet class="d-flex pa-2 light-bg">
                    <p class="text-color">Today's Registration</p>
					<v-spacer></v-spacer>
					<div class="ml-5 count-bg-color"><p class="float_left pr-2 pl-2 letter-spacing-2">{{ count |TwoDigitNumber }}</p></div>
                </v-sheet>
               
                <div class="mt-3">
                    <v-data-table :headers="headers" :items="visitors" 
                    :footer-props="{'items-per-page-options': [5]}" 
                    :items-per-page="5" class="elevation-0"
                    :loading="is_loading">
                        <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                            <tbody>
                                <tr v-for="item in items" :key="item.name">
                                    <td v-if="item.record.name">
                                        <router-link :to="{ name:'showVisitorDetails',params: { id:item.record.id } }">
                                            {{ item.record.name |capitalize}}
                                        </router-link>
                                    </td>
                                    <td v-else>-</td>
									<td v-if="item.from_date">{{formatTime(item.from_date)}}</td><td v-else>-</td>
                                    <td v-if="item.to_date">{{ formatTime(item.to_date)}}</td><td v-else>-</td>
                                   <td v-if="item.purpose">{{ item.purpose}}</td><td v-else>-</td>
    
                                </tr>
                            </tbody>
                        </template>
                        <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                    </v-data-table>
                </div>
                
            </v-card>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    methods: {
         formatDateTime(date) {
            return moment(date).format('DD-MMM-YYYY H:mm')
        },
        getTodaysVisits: function () {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/dashboard/todaysvipvisits`).then((response) => {

                if (response.data.status == 1) {
				
                    this.visitors = response.data.visitors;
                    this.count = response.data.count;
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
    },
    computed: {

    },
    data: () => {
        return {
            count: '',
            visitors: [],
            is_loading: false,
            total_items: 10,
            options: {},
            headers: [{
                    text: 'Name',
                    value: 'record.name',
                    sortable: false
				},
				 {
                    text: 'From Time',
					value: 'from_date',
					 sortable: false
                },
                {
                    text: 'To Time',
					value: 'To_date',
					 sortable: false
                },
                 {
                    text: 'Purpose',
					value: 'purpose',
					 sortable: false
                },
               
               
            ]
        }
    },
    mounted() {
        this.getTodaysVisits();
    }
};
</script>
